const apiLink = "https://qdqs.ordec-auvergne-rhone-alpes.fr/api/";
const adminPassword = "QDQS!Adm1nP4ssw03d!$";

const config = {
    apiLink,
    adminPassword,
};

module.exports = config;
